import React from 'react';
import { UserItem } from './context';
import { StyledGroupToggle, StyledGroupToggleHeader } from './styles';
import { Text3 } from '../../../../../../libs/uiKit/globalStyledComponents';
import Button from '../../../../../../libs/uiKit/button';
import { TrashIcon } from '../../../../../../icons/ui/Trash';
import { useRolesContext } from '../../../ui/context';
import {useGlobalContext} from "../../../../../../apps/main/ui/GlobalContext";
import {Highlighted} from "./Highlighted";

const GroupUserItem: React.FC<UserItem> = user => {
	const { openCreateUserHandler, openDeleteUserHandler } = useRolesContext();
	const { id, fullName, isEnabled, searchWord } = user;

	const {
		user: { isSuper },
	} = useGlobalContext();

	return (
		<StyledGroupToggle>
			<StyledGroupToggleHeader onClick={(): void => openCreateUserHandler({ ...user, isEdit: true, show: true })} isEnabled={isEnabled}>
				<Text3>
					<Highlighted highlight={searchWord} text={fullName}/>
					{!isEnabled && ' (Не активен)'}
				</Text3>
			</StyledGroupToggleHeader>
			{isSuper &&
				<Button appearance='icon' icon={<TrashIcon />} onClick={(): void => openDeleteUserHandler(id)} />
			}
		</StyledGroupToggle>
	);
};

export default React.memo(GroupUserItem);
